<template>
  <div class="main-content">
    <Header />
    <div class="shop_content">
      <div v-if="pending_delivery === 1" class="delivery_status"><router-link :to="{ path: '/delivery_map'}">Delivery In Progress</router-link></div>

      <template v-if="special_banner_url">
        <div v-if="special_banner_text" class="special_banner"><a style="color:white;" v-bind:href=special_banner_url target="_blank" @click="href_click_log('home_banner')">{{special_banner_text}}</a></div>
      </template>
      <template v-else>
        <div v-if="special_banner_text" class="special_banner">{{special_banner_text}}</div>
      </template>

      <div v-if="!is21plus">
        <div class="overlay"></div>
        <div class="new-welcome">
          <img :src='"@/assets/images/UNIBUD-W-TRANSPARENT.svg"' class="unibud-black" alt="logo" />
          <p>You must be 21+ to view this site <br> or <br> 18+ with a medical recommendation </p>
          <button @click="set21plus">Enter!</button>
          <p class="goback">No I'm not</p>
        </div>
      </div>
      <div v-for="(products,index) in productslist" :key="index">
        <ProductSlider :products="products" :listIndex="index"  @openCart="showCart" />
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex'
import Header from '@/components/headershop'
import Footer from '@/components/footer'
import ProductSlider from './components/product_slider'

export default {
  components: {
    Header,
    ProductSlider,
    Footer,
  },
  data() {
    return {
    }
  },
  created() {
    if(!this.getLoaded) {
      this.$router.push({name: 'home'})
    }
  },
  mounted() {
    if(this.signedIn) {
      this.$store.dispatch('auth/getPendingDeliveryStatus');
    }
    // console.log("status==============", this.cartItems)
  },
  computed: {
    ...mapState({
      productslist: state => state.products.productslist,
    }),
    ...mapGetters({
      signedIn: 'auth/signedIn',
      getEnvironment: 'cart/getEnvironment',
      cartItems : 'cart/cartItems',
      is21plus : 'auth/is21plus',
      getLoaded: 'products/getLoaded',
      pending_delivery: 'auth/pending_delivery',
      special_banner_text: 'cart/special_banner_text',
      special_banner_url: 'cart/special_banner_url',
    })
  },
  methods: {
    href_click_log(type) {
      this.$store.dispatch('auth/setHrefClickLog',{type: type, 'url': this.special_banner_url });
    },
    set21plus: function() {
      this.$store.dispatch('auth/set21plus');
    },
  }
}
</script>

<style scoped lang="scss">
  @font-face {
    font-family: "Neue75";
    src: local("Neue75"),
    url('../../assets/fonts/Neue-Haas-Grotesk-Display-Pro-75-Bold.ttf') format("truetype");
  }
  .overlay {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    background-color: rgba(8, 8, 8, 0.36);
    height: 100vh;
    button {
      background-color: yellow;
      width: 80%;
      margin-left: 10%;
      color: black;
      font-size: 2rem;
      border: none;
      outline: none;
      font-weight: 900;
      padding: 10px 0;
      border-radius: 5px;
      margin-top: calc(100vh - 600px);
    }
  }
  h1 {
    margin-top: 15vh;
    color: white;
    text-align: center;
    font-size: 2.5rem;
    text-transform: none;
  }
  .medical {
    text-align: center;
    color: white;
    margin-top: 5vh;
  }
  .new-welcome{
    position: fixed;
    z-index: 1000;
    top: calc(50% - 156px);
    right: 10%;
    left: 10%;
    background-color: white;
    border-radius: 10px;
    text-align: center;
    p{
      color: black;
      font-size: 16px;
      font-weight: bold;
      font-family: "Neue75";
      &.goback {
        font-weight: 900;
        color: #fff;
        background-color: red;
        width: 150px;
        margin: 15px auto 26px;
        padding: 5px;
        border-radius: 8px;
      }
    }
    button{
      border: none;
      font-size: 30px;
      font-family: "Neue75";
      padding: 5px 50px;
      text-align: center;
      color: white;
      background-color: #3DE430;
      border-radius: 10px;
    }
  }
</style>
